export default "__VITE_ASSET__BIChn$7f__"